// Globals
import { useTranslation } from 'react-i18next';

// Models
import { IBaseLLMTemplate } from '@/models/llmTemplate.model';

// Components
import { Table } from '@/ui';

// Helpers
import { getLLMTemplatesColumns } from '../../helpers';

interface ILLMTemplatesTableProps {
  templates: IBaseLLMTemplate[] | null;
  isLoading?: boolean;
}

const LLMTemplatesTable = ({ templates, isLoading }: ILLMTemplatesTableProps) => {
  const { t } = useTranslation();

  return (
    <Table
      columns={getLLMTemplatesColumns(t)}
      rowKey="channelType"
      dataSource={templates ?? []}
      loading={isLoading}
      pagination={false}
      size="small"
    />
  );
};

export default LLMTemplatesTable;
